export enum JournodexSourceTypeEnum {
    contacts = 'Contacts',
    outlets = 'Outlets',
    urls = 'URLs',
    all = 'ALL',
    none = 'NONE',
    sourceGroups = 'Source_Group'
}
